// extracted by mini-css-extract-plugin
export default {"paper":"Opacity_paper__eTbe0"};